import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router"; //引入路由
import store from "./store"; //引入仓库
import "./core/install_plus.js"; //安装自定义指令集
import bootstrap from "./core/bootstrap"; //引导模块
import "./router/user_resource"; //引入用户资源
import "./components/global.less"; //引入全局样式
import "./core/layz_use"; //引入组件
import http from "./api/index.js";
// === 地图
import VueAMap from "vue-amap"; //引入饿了么高德地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "7d7541d614efbf8c1223a7f5f2085595",
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],
  v: "1.4.4" // 默认高德 sdk 版本为 1.4.4
});

Vue.prototype.$http = http;
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  created: bootstrap,
  render: h => h(App)
}).$mount("#app");
